// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_km-0";
export var fileCarousel = "_km-2";
export var removeFileButton = "_km-1";